import { gql } from '@apollo/client';
import type {
  BackgroundColor,
  MotifScheme,
  Template,
} from '@snapchat/snap-design-system-marketing';

import type { ContentfulTypedSysProps } from '../../types/contentful';
import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';
import { type ImageDataProps, fragments as imageFragments } from '../Image';

export const breakFragment = gql`
  fragment BreakAll on Break {
    ...ContentfulSysId
    brandType
    type
    media {
      ...ImageAll
    }
    brandTopColor
    topColor
    brandBottomColor
    bottomColor
    isOverlaid
  }
  ${imageFragments.all}
  ${contentfulSysIdFragment}
`;

export const breakQuery = gql`
  query BreakQuery($preview: Boolean!, $locale: String!, $id: String!) {
    break(preview: $preview, locale: $locale, id: $id) {
      ...BreakAll
    }
  }
  ${breakFragment}
`;

export type BreakType = Template | 'None';

export type BreakBackgroundColor = BackgroundColor | 'Transparent';

export type BreakBrandColor = MotifScheme | 'Transparent';

export interface BreakDataProps extends ContentfulTypedSysProps<'Break'> {
  brandType?: BreakType;
  type?: BreakType;
  media?: ImageDataProps;
  brandTopColor?: BreakBrandColor;
  topColor?: BreakBackgroundColor;
  brandBottomColor?: BreakBrandColor;
  bottomColor?: BreakBackgroundColor;
  isOverlaid?: boolean;
}
